module.exports = __webpack_public_path__ + "static/media/trophy.b68ac074.svg";